import { useCallback, useEffect, useRef, useState } from 'react';

export function useReelClock(duration: number, autoplay: boolean) {
  const [time, setTime] = useState(0);
  const [playing, setPlaying] = useState(autoplay);
  const timeRef = useRef(0);

  useEffect(() => {
    setPlaying(autoplay);
  }, [autoplay]);

  useEffect(() => {
    if (!playing) return;
    let raf = 0;
    let last = performance.now();
    const tick = (now: number) => {
      const dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      timeRef.current = (timeRef.current + dt) % duration;
      setTime(timeRef.current);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [playing, duration]);

  const seek = useCallback((value: number) => {
    timeRef.current = value;
    setTime(value);
  }, []);

  const toggle = useCallback(() => setPlaying((p) => !p), []);

  return { time, timeRef, playing, toggle, seek };
}
